
import { defineComponent, onMounted, ref, Ref } from "vue";
import { api } from "@/services/reports/api";
import { PedidosFacturasPendientes } from "@/types/reports/pedidos/pedidosFacturasPendientes/PedidosfacturasPendientes";
import { PedidoFilter } from "@/types/pedidos/PedidoView";
import loading from "@/components/loading.vue";
import footerPage from "@/components/footerPage.vue";

export default defineComponent({
  name: "PedidosFacturasPendientes",
  components: {
    loading,
    footerPage
  },
  setup() {
    const report: Ref<PedidosFacturasPendientes> = ref({
      numTotalPrendasConfirmadas: "",
      importeTotalPrendasConfirmadas: "",
      numTotalPrendasServidas: "",
      importeTotalPrendasServidas: "",
      clientes: []
    });

    const detail = ref(true);

    const isLoading = ref(true);

    async function getReport() {
      isLoading.value = true;
      const filterString = localStorage.getItem("pedidoFilter");
      let filter = {} as PedidoFilter;
      if (filterString != undefined) filter = JSON.parse(filterString);
      const response = await api.getReportPedidosFacturasPendientes(filter);
      report.value = response;
      isLoading.value = false;
    }

    onMounted(getReport);

    return {
      report,
      detail,
      isLoading
    };
  }
});
